import React, { Component } from 'react'
import './index.css'

export default class ReadMoreLink extends Component {
  render() {
    const { children, handler, inactive } = this.props
    return (
      <div>
        <div className={`link ${inactive ? 'link--inactive' : ''}`} onClick={handler}>
          {children}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/ReadMoreLink/index.js